import React, { useContext } from "react"
import "./style.scss"
import Accordion from "react-bootstrap/Accordion"
import AccordionContext from "react-bootstrap/AccordionContext"
import { useAccordionToggle } from "react-bootstrap/AccordionToggle"
import Form from "react-bootstrap/Form"

const Toggle = ({ children, eventKey, callback }) => {
  const currentEventKey = useContext(AccordionContext)
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  )
  const isCurrentEventKey = currentEventKey === eventKey
  return (
    <button
      className={`arrow ${isCurrentEventKey ? "expanded" : ""}`}
      onClick={decoratedOnClick}
    >
      {children}
    </button>
  )
}
const FilterItem = ({ title, innerFilters, index, handleCheck }) => {
  return (
    <div className="filter-item">
      <Accordion key={index} className="filter-accordion">
        <div className="filter-toggle d-flex flex-row align-items-center justify-content-between">
          <Form.Check>
            <Form.Check.Input
              className="filter-box"
              type="checkbox"
              value={title}
              onChange={handleCheck}
            />
            <Form.Check.Label>{title}</Form.Check.Label>
          </Form.Check>
          <Toggle eventKey={index}>
            <img alt="arrow" />
          </Toggle>
        </div>

        <Accordion.Collapse eventKey={index}>
          <div className="filter-item-body">
            {innerFilters &&
              innerFilters.map((filter, index) => {
                return (
                  <Form.Check
                    className="inner-form-check"
                    key={index}
                    type="checkbox"
                    label={filter.name}
                  />
                )
              })}
          </div>
        </Accordion.Collapse>
      </Accordion>
    </div>
  )
}

const Filter = ({ reset, filters, handleCheck }) => {
  return (
    <div className="filter_by">
      <div className="top_area">
        <p>Filter by</p>
        <p className="reset" onClick={reset} href="#/">
          Reset
        </p>
      </div>
      {filters &&
        filters.map((filter, index) => {
          return (
            <FilterItem
              key={index}
              index={index + 1}
              title={filter.name}
              innerFilters={filter.filters}
              handleCheck={handleCheck}
            />
          )
        })}
    </div>
  )
}

export default Filter
